if (!customElements.get('newsletter-popup')) {
  customElements.define('newsletter-popup', class NewsletterPopup extends HTMLElement {
    constructor() {
      super();
      this.key = this.dataset.storageKey;
      this.seenKey = this.key + '-citysac-last-shown';
      this.subscribedKey = this.key + '-citysac-subscribed-at';
      this.pendingKey = this.key + '-subscription-pending';
      this.delay = Number(this.dataset.delay) || 5000;
      this.testMode = this.dataset.testMode === 'true';
      this.lastScroll = 0;
      this.lastInteraction = 0;
      this.timer = null;
      this.form = this.querySelector('form');

      this.onScroll = () => { this.lastScroll = Date.now(); };
      // Exit intent: the cursor leaving through the top of the viewport.
      this.onExit = e => { if (e.clientY <= 8 && !e.relatedTarget) this.openPopup({ immediate: true }); };
      this.onCartInteraction = () => { this.lastInteraction = Date.now(); this.closePopup(); };
      this.onDocumentClick = e => {
        if (e.target.closest('[href="/cart"],[href*="/cart?"],[data-drawer-toggle],[data-cart-toggle],.cart-drawer-toggle')) this.onCartInteraction();
      };

      if (this.isCartPage()) return;

      if (this.dataset.customerSubscribed === 'true') {
        this.markSubscribed();
      }
      if (this.form) {
        this.form.addEventListener('submit', () => {
          // Record the attempt only after Shopify confirms the subscription on return.
          this.write('sessionStorage', this.pendingKey, '1');
        });
      }
      const posted = new URLSearchParams(location.search).get('customer_posted') === 'true';
      if (posted && this.read('sessionStorage', this.pendingKey) === '1') {
        this.markSubscribed();
        this.erase('sessionStorage', this.pendingKey);
      }

      window.addEventListener('scroll', this.onScroll, { passive: true });
      document.addEventListener('mouseout', this.onExit);
      document.addEventListener('click', this.onDocumentClick, true);

      if (this.form) {
        const success = this.querySelector('.form-status--success,.newsletter-form__message--success');
        if (success) this.markSubscribed();
      }
      this.openPopupIfAllowed();
    }

    /* Storage access throws outright in Safari private mode, with site data
       blocked, and in some in-app webviews. An unreadable store must degrade to
       "nothing recorded yet", not take the whole popup down with it. */
    read(which, key) {
      try { return window[which].getItem(key); } catch (e) { return null; }
    }
    write(which, key, value) {
      try { window[which].setItem(key, value); } catch (e) { /* no-op */ }
    }
    erase(which, key) {
      try { window[which].removeItem(key); } catch (e) { /* no-op */ }
    }

    isCartPage() {
      return /^\/cart\/?$/.test(location.pathname) || document.body.classList.contains('template-cart');
    }
    isCartEngaged() {
      return !!document.querySelector('.drawer-cart.is-open,.cart-drawer.is-open,[data-cart-drawer].is-open,cart-drawer.is-open,.drawer.is-open,.modal.is-open,[aria-modal="true"]:not(newsletter-popup)');
    }
    markSubscribed() {
      const now = String(Date.now());
      this.write('localStorage', this.subscribedKey, now);
      this.write('localStorage', 'citysac-newsletter-subscribed-at', now);
    }
    lastSubscription() {
      return Number(this.read('localStorage', 'citysac-newsletter-subscribed-at') || this.read('localStorage', this.subscribedKey) || 0);
    }
    eligible() {
      if (this.testMode) return true;
      if (this.isCartPage()) return false;
      const now = Date.now();
      const last = this.lastSubscription();
      if (last && now - last < 30 * 86400000) return false;
      const seen = Number(this.read('localStorage', this.seenKey) || 0);
      if (seen && now - seen < 86400000) return false;
      return true;
    }
    openPopupIfAllowed() {
      if (!this.eligible()) return;
      const privacy = window.Shopify?.customerPrivacy;
      if (privacy && !privacy.userCanBeTracked() && !privacy.userDataCanBeSold()) {
        document.addEventListener('trackingConsentAccepted', () => this.openPopupWithDelay(), { once: true });
      } else {
        this.openPopupWithDelay();
      }
    }
    openPopupWithDelay(delay) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.openPopup(), delay === undefined ? this.delay : delay);
    }
    openPopup(options) {
      if (!this.eligible()) return;
      if (this.classList.contains('is-open')) return;

      // The cart always wins, however the popup was triggered.
      if (this.isCartEngaged()) {
        this.openPopupWithDelay(3000);
        return;
      }
      /* Exit intent is a deliberate signal, so it skips the idle gates. Without
         this, the commonest exit motion - scroll, then flick up to the tab bar -
         lands inside the 8s scroll window and the popup never fires. */
      const immediate = options && options.immediate;
      if (!immediate && (Date.now() - this.lastScroll < 8000 || Date.now() - this.lastInteraction < 10000)) {
        this.openPopupWithDelay(3000);
        return;
      }

      this.write('localStorage', this.seenKey, String(Date.now()));
      this.classList.add('is-open');
      if (!this.escHandler) this.escHandler = e => { if (e.key === 'Escape') this.closePopup(); };
      document.addEventListener('keydown', this.escHandler);
    }
    closePopup() {
      this.classList.remove('is-open');
      if (this.escHandler) document.removeEventListener('keydown', this.escHandler);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('mouseout', this.onExit);
      document.removeEventListener('click', this.onDocumentClick, true);
      if (this.escHandler) document.removeEventListener('keydown', this.escHandler);
    }
  });
}
